// src/serviceWorkerRegistration.js

export function register() {
  if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`;

      navigator.serviceWorker
        .register(swUrl)
        .then((registration) => {
          console.log('✅ ServiceWorker registered:', registration);
        })
        .catch((error) => {
          console.error('❌ ServiceWorker registration failed:', error);
        });
    });
  }
}
